import { useMemo } from "react";

import { ICatalogue } from "../../../../apis/useGetCatalogueData/types";
import SetItemDisplay from "./SetItemDisplay";
import { IPricedAccordionSelection } from "./types";

export const useSetItemSelection = (items: ICatalogue[], base_price: number) => {
	const selections = useMemo((): IPricedAccordionSelection[] => {
		const nonsetitems = items.filter(
			({ food_supplier_set_items }) => !food_supplier_set_items?.length
		);

		return nonsetitems.map(({ id, title, title_cn, price, inventory_count }) => {
			const price_diff = price - base_price;
			const is_oos = inventory_count === 0;

			return {
				id,
				selection_display: (
					<SetItemDisplay
						title={title}
						title_cn={title_cn}
						base_price={base_price}
						price={price}
						is_oos={is_oos}
					/>
				),
				selected_display: (
					<SetItemDisplay
						title={title}
						title_cn={title_cn}
						base_price={base_price}
						price={price}
						is_oos={false}
					/>
				),
				price_diff: Math.max(price_diff, 0),
				is_oos,
				disabled: is_oos,
			};
		});
	}, [items, base_price]);

	return {
		selections,
	};
};
